import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as TransactionIcon } from '../../../assets/icons/sidebar/sidebar-payment.svg';
import { ReactComponent as SlashIcon } from '../../../assets/icons/slash.svg';
import { ReactComponent as StopIcon } from '../../../assets/icons/stop-circle.svg';
import DefaultApiLimit from '../../../config/defaultLimit';
import {
  CommercialSessionInterface,
  PersonalSessionInterface,
} from '../../../interface/charging-session.interface';
import { TransactionEMSPInterFace } from '../../../interface/emsp-transaction-interface';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { setSelectedDevice } from '../../../redux/slices/DeviceManagementSlice';
import {
  disablePaymentManagementApplied,
  fetchAllPayments,
  fetchListPaymentMethodFilters,
  updatePaymentManagementFilters,
  setSortData,
  refreshAllPayments,
} from '../../../redux/slices/EMSPPersonalSessionSlice';
import { setNotificationMessage } from '../../../redux/slices/NotificationManagementSlice';
import { setPageTitle } from '../../../redux/slices/PageTitleSlice';
import { setSidePanelData } from '../../../redux/slices/TableSidePanelSlice';
import CustomActionBar from '../../../shared-components/custom-action-bar/CustomActionBar';
import CustomRadioButton from '../../../shared-components/custom-radio-button/CustomRadioButton';
import CustomTable from '../../../shared-components/custom-table/CustomTable';
import ModalBox from '../../../shared-components/modal-box/ModalBox';
import SuccessNotification from '../../../shared-components/success-notification/SuccessNotification';
import DeviceSidePanel from '../../../shared-components/table-side-panel/DeviceSidePanel';
import EndConsumerSidePanel from '../../../shared-components/table-side-panel/EndConsumerSidePanel';
import { GetParametersFromCommonFilters } from '../../../shared-functions/CommonFilters';
import { getDaysBetween, removeEmptyKeys } from '../../../shared-functions/DateTime';
// import { exportCSV, exportPDF } from '../../../shared-functions/ExportFile';
import { permissionCheck } from '../../../shared-functions/JWTDocodeFunction';
import occpEvent from '../../../utils/api/v2/emsp-session';

interface ModalInterface {
  title: string;
  header: boolean;
  content: JSX.Element | null;
  rightCorner: string;
  notification: boolean;
}

/**
 * Personal Session Table Component
 * @param {any} param0 - The param0
 * @param {any} param0.currentPage - The currentPage prop
 * @param {any} param0.setCurrentPage - The setCurrentPage prop
 */
function PersonalSessionTable({
  currentPage,
  setCurrentPage,
}: {
  currentPage: string;
  setCurrentPage: (value: string) => void;
}) {
  const { t } = useTranslation('transaction');
  const dispatch = useAppDispatch();
  const [openStatus, setOpenStatus] = useState<boolean>(false);
  const [modalView, setModalView] = useState<ModalInterface>({
    title: '',
    content: null,
    header: true,
    rightCorner: '',
    notification: false,
  });
  const navigate = useNavigate();

  // @ts-ignore
  const {
    payments,
    limit,
    page,
    totalPages,
    totalResults,
    loading,
    filterListLoading,
    filters,
    isFilterUpdated,
    sortField,
    sortBy,
    TotalFinising,
    totalInprocess,
    totalFailed,
  } = useAppSelector((state) => state.emspPersonalTransaction);
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  // const [isPolling, setIsPolling] = useState<boolean>(false);
  //   const navigate = useNavigate();
  // const { deviceDetails } = useAppSelector((state) => state.tableSidePanel);
  const { deviceDetails } = useAppSelector((state) => state.tableSidePanel);
  const [activeStatus, setActiveStatus] = useState<string>('');
  // const [exportLoader, setExportLoader] = useState(false);
  // const [hiddenColumns, setHiddenColumns] = useState<string[]>([]);
  const isStatusClicked = React.useRef(false);

  /**
   * Function to handle radio button change
   * @param {any} name - The name
   * @param {any} value - The value
   */
  const handleAvailabilityChange = (name: string, value: string) => {
    setCurrentPage(value);
  };

  /**
   * Function to open device view model
   * @param {any} _ - The _
   * @param {any} newTab - The newTab
   */
  const handleOpenModelView = (_: any, newTab: boolean) => {
    if (deviceDetails) {
      dispatch(
        setSelectedDevice({
          id: deviceDetails?.id,
          name: deviceDetails?.chargingPointName,
          chargingPointSn: deviceDetails?.chargingPointSn,
          modelSeries: deviceDetails?.modelSeries,
        }),
      );

      if (newTab) {
        const url = `/ev-admin/charger-management/${deviceDetails.id}/device-details?searchBy=${deviceDetails.chargingPointName}`;
        window.open(url, '_blank'); // opens in a new tab
      } else {
        navigate({
          pathname: `/ev-admin/charger-management/${deviceDetails.id}/device-details`,
          search: `?searchBy=${deviceDetails.chargingPointName}`,
        });
      }
    } else {
      console.log('Error while opening device in separate page');
    }
  };
  /**
   * Modal box close function
   * @param {any} message - The message
   */
  const showSuccessNotification = (message: string) => {
    if (message) {
      setOpenStatus(true);
      setModalView({
        title: '',
        header: false,
        content: (
          <SuccessNotification
            title={message}
            description=""
            notificationCloseTimer={3000}
            onNotificationClose={() => {
              setOpenStatus(false);
            }}
          />
        ),
        rightCorner: '',
        notification: true,
      });
    } else {
      setOpenStatus(false);
    }
  };

  // /**
  //  * Function to open device view model
  //  */
  // const handleOpenModelView = (_: any, newTab: boolean) => {
  //     if (deviceDetails) {
  //         dispatch(
  //             setSelectedDevice({
  //                 id: deviceDetails?.id,
  //                 name: deviceDetails?.chargingPointName,
  //                 chargingPointSn: deviceDetails?.chargingPointSn,
  //                 modelSeries: deviceDetails?.modelSeries,
  //             }),
  //         );

  //         if (newTab) {
  //             const url = `/ev-admin/device-management/device/${deviceDetails.id}/device-details?searchBy=${deviceDetails.chargingPointName}`;
  //             window.open(url, '_blank'); // opens in a new tab
  //         } else {
  //             navigate({
  //                 pathname: `../device-management/device/${deviceDetails.id}/device-details`,
  //                 search: `?searchBy=${deviceDetails.chargingPointName}`,
  //             });
  //         }
  //     } else {
  //         console.log('Error while opening device in separate page');
  //     }
  // };
  /**
   * Fetch the session details in redux
   * @param {any} data - The data
   */
  const fetchSessions = (data: any) => {
    if (getDaysBetween(data.startDate, data.endDate) > 30) {
      dispatch(
        setNotificationMessage({
          message: t('dateRangeLimitMessage'),
          status: true,
          type: 'error',
          code: 400,
        }),
      );
      return;
    }

    if (!loading) {
      dispatch(
        fetchAllPayments({
          ...data,
          ...(activeStatus ? { status: activeStatus } : {}),
        }),
      );
    }
  };
  /**
   * Function to refresh data
   */
  const handleRefresh = () => {
    const queryParameters = GetParametersFromCommonFilters(filters);
    const sortValue = sortField && sortBy ? { sortField, sortBy } : {}; // no sort if empty
    fetchSessions({ ...queryParameters, page, limit, ...sortValue });
  };
  /**
   * Function to handle stop button click
   * @param {any} data - The data
   */
  const handleStop = (data: PersonalSessionInterface | string[]) => {
    let itemsToProcess: PersonalSessionInterface[] = [];

    if (Array.isArray(data)) {
      itemsToProcess = payments.filter((session) =>
        data.includes(session.sessionId),
      ) as unknown as PersonalSessionInterface[];
    } else {
      itemsToProcess = [data];
    }

    if (itemsToProcess.length === 0) return;

    const promises = itemsToProcess.map((item: any) => {
      const payload = {
        // eslint-disable-next-line camelcase
        session_id: item.sessionId || item.session_id,
      };
      return occpEvent.remoteStopTransaction(payload);
    });

    Promise.all(promises)
      .then(() => {
        showSuccessNotification(
          itemsToProcess.length > 1
            ? t('transactionsStopRequestSuccess')
            : t('transactionStopRequestSuccess'),
        );
        handleRefresh();
        if (Array.isArray(data)) {
          setSelectedRows([]);
        }
      })
      .catch((error) => {
        dispatch(
          setNotificationMessage({
            status: true,
            message: error?.response?.data?.message || t('errorMessage'),
            type: 'error',
            code: 0,
          }),
        );
      });
  };

  /**
   * Function to handle force stop button click
   * @param {any} data - The data
   */
  const handleForceStop = (data: PersonalSessionInterface | string[]) => {
    let itemsToProcess: PersonalSessionInterface[] = [];

    if (Array.isArray(data)) {
      itemsToProcess = payments.filter((session) =>
        data.includes(session.sessionId),
      ) as unknown as PersonalSessionInterface[];
    } else {
      itemsToProcess = [data];
    }

    if (itemsToProcess.length === 0) return;

    const promises = itemsToProcess.map((item: any) => {
      const payload = removeEmptyKeys({
        // eslint-disable-next-line camelcase
        session_id: item.sessionId || item.session_id,
        sessionId: item.sessionId || item.session_id,
        chargingPointSn: item.chargingPointSn || item.evseUid,
        transactionId: item.transactionId || item.sessionId,
        userCustomId: item.userCustomId,
        forceStopTransaction: true,
      });
      return occpEvent.remoteStopTransaction(payload);
    });

    Promise.all(promises)
      .then(() => {
        showSuccessNotification(
          itemsToProcess.length > 1
            ? t('transactionsForceStopRequestSuccess')
            : t('transactionForceStopRequestSuccess'),
        );
        handleRefresh();
        if (Array.isArray(data)) {
          setSelectedRows([]);
        }
      })
      .catch((error) => {
        dispatch(
          setNotificationMessage({
            status: true,
            message: error?.response?.data?.message || t('errorMessage'),
            type: 'error',
            code: 0,
          }),
        );
      });
  };
  const column = [
    {
      label: t('date'),
      accessorKey: 'createdAt' as keyof TransactionEMSPInterFace,
      sortAllow: true,
      /**
       * Date
       * @param {any} rowData - The row data
       * @returns {any} Date value
       */
      customData: (rowData: TransactionEMSPInterFace) => <span>{rowData?.date}</span>,
    },
    {
      label: t('time'),
      accessorKey: 'time' as keyof TransactionEMSPInterFace,
      sortAllow: true,
      /**
       * Time view
       * @param {any} transaction - The transaction data
       */
      customData: (transaction: TransactionEMSPInterFace) => (
        <div className="table-row-each-data">{transaction.time}</div>
      ),
    },
    {
      label: t('deviceId'),
      accessorKey: 'userName' as keyof TransactionEMSPInterFace,
      queryParamsKey: 'userCustomId',
      queryParamsValue: 'userCustomId',
      sortAllow: true,
      sidePanelComponent: <EndConsumerSidePanel fetchIdFrom="queryParams" />,
      /**
       * testing
       * @param {any} rowData - The row data
       * @returns {any} The user name
       */
      customData: (rowData: TransactionEMSPInterFace) => (
        <p
          key={rowData._id}
          role="presentation"
          onClick={() => {
            navigate(`?userCustomId=${rowData.userCustomId}`);
            dispatch(
              setSidePanelData({
                key: 'Transactions',
                value: rowData._id,
              }),
            );
          }}
          style={{
            cursor: 'pointer',
            color: 'var(--primary-color)',
            textDecoration: 'underline',
          }}>
          {rowData.userName}
        </p>
      ),
    },
    {
      label: t('chargingPoint'),
      accessorKey: 'chargingPointSn' as keyof TransactionEMSPInterFace,
      queryParamsKey: 'deviceId',
      queryParamsValue: 'chargingPointSn',
      sidePanelComponent: <DeviceSidePanel fetchIdFrom="queryParams" />,
      handleClickExpandView: handleOpenModelView,
    },
    {
      label: t('transactionId'),
      accessorKey: 'transactionId' as keyof TransactionEMSPInterFace,
    },
    {
      label: t('transactionStartsAt'),
      accessorKey: 'transactionStartsAt' as keyof TransactionEMSPInterFace,
    },
    {
      label: t('status') || 'Status',
      accessorKey: 'status' as keyof TransactionEMSPInterFace,
      /**
       * Custom data for the status column
       * @param {TransactionEMSPInterFace} rowData - The row data
       * @returns The status badge element
       */
      customData: (rowData: TransactionEMSPInterFace) => {
        let statusClass = '';
        if (rowData?.status) {
          const statusLower = rowData.status.toLowerCase();
          if (statusLower === 'finished') {
            statusClass = 'status-finished';
          } else if (
            statusLower === 'inprogress' ||
            statusLower === 'in progress' ||
            statusLower === 'in_progress'
          ) {
            statusClass = 'status-inProgress';
          } else if (statusLower === 'pending') {
            statusClass = 'status-pending';
          } else if (statusLower === 'terminated') {
            statusClass = 'status-terminated';
          } else if (statusLower === 'failed') {
            statusClass = 'status-failed';
          }
        }
        return (
          <span className={`status-badge ${statusClass}`}>
            <span className="status-text capitalize">
              {rowData?.status ? t(rowData.status) : t('na')}
            </span>
          </span>
        );
      },
    },
    {
      label: t('actions'),
      accessorKey: 'id' as keyof TransactionEMSPInterFace,
      sticky: 'right' as const,
      /**
       * Custom data for the actions column
       * @param {any} rowData session data
       * @returns {any} JSX element
       */
      customData: (rowData: TransactionEMSPInterFace) => {
        if (rowData?.status === 'inProgress' && permissionCheck('mobilityActiveSessionStop')) {
          return (
            <div className="stop-buttons">
              <span role="presentation" title={t('stop')}>
                <StopIcon
                  onClick={() => handleStop(rowData as unknown as CommercialSessionInterface)}
                />
              </span>
              {rowData._id === 'inPout' && (
                <span role="presentation" title={t('forceStop')}>
                  <SlashIcon
                    onClick={() =>
                      handleForceStop(rowData as unknown as CommercialSessionInterface)
                    }
                  />
                </span>
              )}
            </div>
          );
        }
        return <div>{t('na')}</div>;
      },
    },
  ];

  /**
   * Table pagination function
   * @param {any} value - The value
   */
  const pageNateLimitChange = (value: any) => {
    const queryParameters = GetParametersFromCommonFilters(filters);
    const sortValue = sortField && sortBy ? { sortField, sortBy } : {}; // no sort if empty
    fetchSessions({ ...value, ...queryParameters, ...sortValue });
  };

  /**
   * Current columns for export
   */
  // const currentColumns = [
  //   { label: t('sNo'), accessorKey: '__serial__' },
  //   { label: t('date'), accessorKey: 'createdAt' },
  //   { label: t('time'), accessorKey: 'time' },
  //   { label: t('deviceId'), accessorKey: 'userName' },
  //   { label: t('chargingPoint'), accessorKey: 'chargingPointSn' },
  //   { label: t('transactionId'), accessorKey: 'transactionId' },
  //   { label: t('transactionStartsAt'), accessorKey: 'transactionStartsAt' },
  //   { label: t('status'), accessorKey: 'status' },
  // ];

  /**
   * Filtering columns for export without hidden columns
   */
  // const exportCurrentColumns = currentColumns.filter(
  //   (col) => col.accessorKey === '__serial__' || !hiddenColumns.includes(col.accessorKey),
  // );

  /**
   * Export data function
   * @param {any} type - The type
   */
  // const exportDataPdfOrCSV = (type: string) => {
  //   setExportLoader(true);

  //   const queryParameters = GetParametersFromCommonFilters(filters);

  //   occpEvent
  //     .fetchPersonalSessionExport(
  //       removeEmptyKeys({
  //         ...queryParameters,
  //         sortBy,
  //         sortField,
  //       }),
  //     )
  //     .then((response) => {
  //       const headers = exportCurrentColumns.map((col) => col.label);

  //       const rows = response.data.map((row: TransactionEMSPInterFace, index: number) =>
  //         exportCurrentColumns.map((col) => {
  //           switch (col.accessorKey) {
  //             case '__serial__':
  //               return index + 1;

  //             case 'createdAt':
  //               return row.date || '-';

  //             case 'time':
  //               return row.time || '-';

  //             default:
  //               return (row as any)[col.accessorKey] ?? '-';
  //           }
  //         }),
  //       );

  //       setExportLoader(false);

  //       if (rows.length > 0) {
  //         if (type === 'csv') {
  //           exportCSV(headers, rows, 'personal-session-list.csv');
  //         } else {
  //           exportPDF(headers, rows, 'personal-session-list.pdf');
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       setExportLoader(false);

  //       dispatch(
  //         setNotificationMessage({
  //           status: true,
  //           message: error?.response?.data?.message || t('errorMessage'),
  //           type: 'error',
  //           code: error?.response?.status || 500,
  //         }),
  //       );
  //     });
  // };

  /**
   * Function to auto refresh data
   */
  const handleAutoRefresh = () => {
    const queryParameters = GetParametersFromCommonFilters(filters);

    dispatch(
      refreshAllPayments({
        ...queryParameters,
        page,
        limit,
        sortBy,
        sortField,
      }),
    );
  };

  /**
   * Handle the filter data clear function
   * @param {any} sortData - The sortData
   */
  const handleSortFunction = (sortData: any) => {
    const queryParameters = GetParametersFromCommonFilters(filters);
    dispatch(setSortData(sortData));
    fetchSessions({
      ...queryParameters,
      sortBy: sortData.sortBy,
      sortField: sortData.sortField,
      page: DefaultApiLimit.page,
      limit,
    });
  };

  /**
   * Poll session data every 10 seconds
   */
  // useEffect(() => {
  //   let timeout: NodeJS.Timeout;
  //   if (isPolling) {
  //     timeout = setTimeout(() => {
  //       handleRefresh();
  //       setIsPolling(false);
  //     }, 10000);
  //   }
  //   return () => clearTimeout(timeout);
  // }, [isPolling]);
  useEffect(() => {
    if (isFilterUpdated || payments.length === 0 || isStatusClicked.current) {
      isStatusClicked.current = false;
      const queryParameters = GetParametersFromCommonFilters(filters);
      fetchSessions({
        page: DefaultApiLimit.page,
        limit,
        ...queryParameters,
      });
      dispatch(disablePaymentManagementApplied());
    }
  }, [filters, activeStatus]);

  useEffect(() => {
    dispatch(setPageTitle({ title: t('session'), icon: <TransactionIcon />, count: totalResults }));
  }, [totalResults]);

  /**
   * Check if status filter is currently active
   * @param {string} statusValue - The status value to check
   * @returns {boolean} True if active
   */
  const isStatusActive = (statusValue: string): boolean => {
    return activeStatus === statusValue;
  };

  /**
   * Handle status badge click to apply/toggle filter
   * @param {string} statusValue - The status value to filter by
   */
  const handleStatusClick = (statusValue: string) => {
    isStatusClicked.current = true;
    setActiveStatus((previous) => (previous === statusValue ? '' : statusValue));
  };

  return (
    <div className="payment-management-wrap">
      <ModalBox
        open={openStatus}
        title={modalView.title}
        content={modalView.content}
        closeModal={() => setOpenStatus(false)}
        header={modalView.header}
        rightCorner={modalView.rightCorner}
        notification={modalView.notification}
      />
      <div className="stats-bar">
        <div className="stat-item" key="total">
          <span className="stat-label">Total</span>
          <span className="stat-value">{totalResults ?? 0}</span>
        </div>
        <div className="stat-divider" />
        <div
          className={`stat-badge finished-badge ${isStatusActive('finished') ? 'active' : ''}`}
          key="finished"
          role="presentation"
          onClick={() => handleStatusClick('finished')}>
          <span className="badge-dot" />
          Finished: {TotalFinising ?? 0}
        </div>
        <div
          className={`stat-badge inprogress-badge ${isStatusActive('inprogress') ? 'active' : ''}`}
          key="inprogress"
          role="presentation"
          onClick={() => handleStatusClick('inprogress')}>
          <span className="badge-dot" />
          In Progress: {totalInprocess ?? 0}
        </div>
        <div
          className={`stat-badge terminated-badge ${isStatusActive('terminated') ? 'active' : ''}`}
          key="terminated"
          role="presentation"
          onClick={() => handleStatusClick('terminated')}>
          <span className="badge-dot" />
          Terminated: {totalFailed ?? 0}
        </div>
      </div>
      <div className="table-content">
        <CustomTable
          dataKey="Transactions"
          version="v2"
          header={column}
          data={payments}
          limit={limit}
          page={page}
          totalPages={totalPages}
          totalResults={totalResults}
          loading={loading}
          serialNo
          sortData={{ sortBy, sortField }}
          handleSortChange={handleSortFunction}
          pageLimitChange={pageNateLimitChange}
          sizeChangeButtonRequired
          // exportLoader={exportLoader}
          // exportDataPdfOrCSV={
          //   permissionCheck('mobilitySessionsExport') ? exportDataPdfOrCSV : undefined
          // }
          // onHiddenColumnsChange={setHiddenColumns}
          filters={filters}
          autoRefreshEnabled
          filtersToDispatch={updatePaymentManagementFilters}
          filterListLoading={filterListLoading}
          filterListToDispatch={fetchListPaymentMethodFilters}
          hidedColumnNames={[
            'sessionAmount',
            'platformAmount',
            'networkRevenue',
            'sharableRevenue',
          ]}
          disableAutoRefreshToggle
          height={320}
          rightTopContent={
            <div className="revenue-management-toggle-wrap">
              <CustomRadioButton
                name=""
                value="commercial"
                label={t('commercialCharger')}
                selected={currentPage === 'commercial'}
                onChangeFunc={handleAvailabilityChange}
              />
              <CustomRadioButton
                name=""
                value="personal"
                label={t('personalCharger')}
                selected={currentPage === 'personal'}
                onChangeFunc={handleAvailabilityChange}
              />
            </div>
          }
          requiredRefreshToggle
          refreshFunction={handleAutoRefresh}
          refreshRequired
          handleRefresh={handleRefresh}
          refershCurrentPages={handleRefresh}
          hoverLabel={t('refresh')}
          checkbox
          selectedRows={selectedRows}
          onSelectedRowsChange={setSelectedRows}
          selectKey="id"
          isRowSelectable={(row) => row.status === 'inProgress'}
        />
        <CustomActionBar
          selectedRows={selectedRows}
          onSelectedRowsChange={setSelectedRows}
          actions={[
            {
              label: t('stop'),
              // icon: <StopIcon />,
              buttonType: 'error',
              /**
               * handle stop
               * @todo
               */
              onClick: () => handleStop(selectedRows),
            },
            // {
            //   label: t('forceStop'),
            //   // icon: <SlashIcon />,
            //   buttonType: 'error',
            //   /**
            //    * handle force stop
            //    * @todo
            //    */
            //   onClick: () => handleForceStop(selectedRows),
            // },
          ]}
        />
      </div>
    </div>
  );
}

export default PersonalSessionTable;
